import { useRef, useState } from 'react';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { authService } from 'services';
import CustomToast from 'views/components/form-inputs/alert/index';
import { showTostify } from 'utils/common-functions';
import { AuthImg } from './images';
import Logo from 'assets/images/logo.svg'
import { SEOHeader } from 'views/components';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const toastRef = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required().label('Email or username'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const data = await authService.forgotPassword(values)
        if (data.error === false) {
          showTostify(toastRef, 'success', data.message)
          resetForm({})
        } else {
          showTostify(toastRef, 'error', data.message)
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message)
      }
      finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <SEOHeader title="Forgot Password" />
      <div className="auth-details flex h-screen">
        <CustomToast ref={toastRef} />
        <div className="flex align-items-center justify-content-center flex-column w-6">
          <div className="login-width my-auto">
            <form onSubmit={formik.handleSubmit}>
              <img src={Logo} alt="Clapping Hands" className='w-13rem' />
              <h2 className="flex align-items-center my-2">Forgot Password? 🔒</h2>
              <p className="mb-4">Enter your email and we'll send you instructions to reset your password</p>

              <div className="form-group">
                <div className="login-input">
                  <label htmlFor="email">Email or Username<span className='required-field'>*</span></label>
                  <InputText
                    id="email"
                    name="email"
                    value={formik.values.email}
                    placeholder="Enter here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`form-control ${formik.errors.email && formik.touched.email ? 'p-invalid' : ''}`}
                    required
                  />
                  {formik.touched.email && formik.errors.email && (
                    <Message severity="error" text={formik.errors.email} />
                  )}
                </div>
              </div>
              <div className="flex justify-content-center">
                <Button
                  label={loading ? "" : 'Send reset link'}
                  type="submit"
                  className='primary w-full'
                  disabled={!formik.isValid || formik.isSubmitting}
                  loading={loading}
                />
              </div>
              <div className="account-details flex justify-content-center mt-3">
                <p className='mb-0 mt-0'>
                  <Link to="/login"><i className="pi pi-arrow-left"></i>&nbsp; Back to login</Link>
                </p>
              </div>
            </form>
          </div>
          <div className='copy-right'>
            <p className='m-0'>© 2024 Bookmydiscount, All rights reserved.</p>
          </div>
        </div>
        <div className="flex justify-content-end align-items-center bg-white w-6 p-4 right-images">
          <div className="img-container">
            <img src={AuthImg} alt="character" className="character-image" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;  